/**
 * Sprint 23.8 — Recent activity sidebar block (block 4).
 *
 * The last 5 significant workspace events (created / archived / retro composed /
 * …), each a summary + relative time. Polls `list_workspace_activity(5)` on its
 * own 60s cadence.
 */

import { type CSSProperties } from "react";
import { SidebarBlock } from "../shell/SidebarBlock";
import { useWorkspaceActivity } from "../../hooks/use-workspace-activity";
import { formatAge } from "./format";

export function RecentActivityBlock() {
  const { data, isLoading } = useWorkspaceActivity(5);
  const events = data ?? [];

  return (
    <SidebarBlock title="Recent activity">
      {events.length === 0 ? (
        <div style={empty}>{isLoading ? "Loading…" : "No recent activity."}</div>
      ) : (
        <div style={list}>
          {events.map((e) => {
            const age = formatAge(e.age_seconds);
            return (
              <div key={e.id}>
                <div style={summary}>{e.summary}</div>
                {age && <div style={time}>{age}</div>}
              </div>
            );
          })}
        </div>
      )}
    </SidebarBlock>
  );
}

const list: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: 8,
  fontSize: 11,
  lineHeight: 1.5,
};

const summary: CSSProperties = {
  color: "var(--color-text-primary)",
};

const time: CSSProperties = {
  color: "var(--color-text-tertiary)",
  fontSize: 10,
};

const empty: CSSProperties = {
  fontSize: 12,
  color: "var(--color-text-tertiary)",
};
